import { ReactComponent as Wordmark } from '../../brand/wordmark.svg'
import styles from './index.module.css'

/**
 * What the router draws while the flow's code loads: the ground and the flow's nav, wordmark in
 * place, so the first step arrives under a frame that's already there instead of on a blank page.
 * Part of every page's first load (src/router.js), so it's only this and the wordmark.
 */
const StartLoading = () => (
  <div className={styles.page} aria-busy="true">
    <div className={styles.nav}>
      <Wordmark className={styles.wordmark} role="img" aria-label="Wally" />
    </div>
  </div>
)

export default StartLoading
